import { useToast } from "@/components/feature/ToastProvider";

interface ShareDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

const platforms = [
  { key: "weibo", label: "微博", icon: "ri-weibo-fill" },
  { key: "wechat", label: "微信", icon: "ri-wechat-fill" },
  { key: "qq", label: "QQ", icon: "ri-qq-fill" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function ShareDialog({ open, onClose, title }: ShareDialogProps) {
  const { showToast } = useToast();

  if (!open) return null;

  const handleShare = (label: string) => {
    showToast(`${label}分享为演示功能，待后续接入`);
  };

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-foreground-950/50 px-4"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full max-w-sm rounded-lg border border-background-300 bg-background-50 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-base font-bold text-foreground-950">分享内容</h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-3">
          {platforms.map((platform) => (
            <button
              key={platform.key}
              type="button"
              onClick={() => handleShare(platform.label)}
              className="flex flex-col items-center gap-2 rounded-md border border-background-200 py-3 transition-colors hover:border-primary-300 hover:bg-primary-50"
            >
              <i className={`${platform.icon} text-xl text-primary-600`}></i>
              <span className="text-xs text-foreground-600">{platform.label}</span>
            </button>
          ))}
        </div>

        <p className="mt-5 rounded-md bg-accent-50 px-3 py-2 text-xs text-accent-900">
          提示：分享功能为演示功能，待后续接入，不会真正跳转到第三方平台。
        </p>
      </div>
    </div>
  );
}